import { Box } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { useFilterContext } from 'src/contexts/FilterContext';

type CreateForecastButtonProps = {
  onClick: () => void;
};

export const CreateForecastButton: React.FC<CreateForecastButtonProps> = ({
  onClick,
}) => {
  const { currentModelVersion } = useFilterContext();

  return (
    <Box>
      <Button
        variant="primary"
        buttonName="create-forecast"
        isDisabled={!currentModelVersion}
        onClick={onClick}>
        <Icon iconName="plus" boxSize={4} mr={2} color="white" />
        Create Forecast
      </Button>
    </Box>
  );
};
